<template>

  <div>
    <el-table v-if="!adding" :data="mapCoords" style="width: 100%">

        <el-table-column label="Nominal" class-name="hidden-md-and-down">
            <el-table-column label="Lat." prop="nominalLat" class-name="hidden-md-and-down" />
            <el-table-column label="Lng." prop="nominalLng" class-name="hidden-md-and-down" />
        </el-table-column>

        <el-table-column label="Candidate" class-name="hidden-md-and-down">
            <el-table-column label="Lat." prop="candLat"  class-name="hidden-md-and-down" />
            <el-table-column label="Lng." prop="candLng" class-name="hidden-md-and-down" />
        </el-table-column>

        <el-table-column label="Distance" class-name="hidden-md-and-down">
            <el-table-column label="m." prop="distance" class-name="hidden-md-and-down" />
        </el-table-column>

    </el-table>

    <br />

    <google-map
      :lat="rowData.site.latitude"
      :lng="rowData.site.longitude"
      :zoom="17"
      :markers="rta.markers"

      :add-markers="editable && !disabled"
      :delete-markers="editable && !disabled"

      :drag-markers="editable && !disabled"

      show-nominal
      :map-style="style"
      :options="['option', 'access', 'power', 'building']"
      :optionIcons="['fa fa-bullseye', 'fa fa-road', 'fa fa-plug', 'fa fa-home']"
      :optionMapPins="mapPins"
      @changed="updateMarker"
       />


    <edit-pane
      ref="opt"
      :prefix="rta.clientStatus ? rta.clientStatus : 'Option: '"
      :title="'#' + rta.optionNo + ' Site Name: ' + site.siteName"
      :editable="editable"
      @save="onSave"
      @cancel="onCancel"
      @edit="onEdit"
     />

     <section v-if="isTowerCo() && isApproved()">
       <center style="padding-bottom: 1em;">
         <el-button type="success" @click="approve">Approve RTA</el-button>
       </center>
     </section>

      <el-form inline :model="rta" label-position="top">

        <el-tabs type="border-card">

          <el-tab-pane label="Details">

            <el-form :model="rta" label-position="left" inline label-width="120px">

              <select-site-status v-if="isTowerCo()" v-model="rta.siteStatus" :disabled="disabled" />
              <select-sharer v-if="isTowerCo() && !rta.client_id" v-model="rta.client_id" />

              <el-row :gutter="guts">

                <el-col :sm="24" :md="8" :lg="8">
                  <text-input label="Client Ref." v-model="rta.clientRef" :placeholder="(rta.client && rta.client.shortName ? rta.client.shortName : 'Our') + ' Ref:'" :disabled="disabled || isTowerCo()" />
                </el-col>

                <el-col :sm="24" :md="12" :lg="8" align="center">
                  <text-input label="Option Title" v-model="rta.title" placeholder="Option Title" :disabled="disabled" />
                </el-col>

                <el-col :sm="24" :md="8" :lg="8">
                  <text-input label="Ref." v-model="rta.ref" :placeholder="xolasClient().shortName + ' Ref:'" :disabled="disabled || isTelco()" />
                </el-col>

              </el-row>

              <el-row :gutter="guts">

                <el-col :sm="24" :md="8" :lg="6">
                  <span v-html="addSuffix(rta.optionNo)"></span> Option
                </el-col>

                <el-col :sm="24" :md="8" :lg="12" align="center">
                  &nbsp;
                </el-col>

                <el-col :sm="24" :md="12" :lg="6">
                  <date-input label="Survey Date" v-model="rta.surveyDate" :disabled="disabled" />
                </el-col>

              </el-row>

            </el-form>

            <el-row :gutter="guts">

              <el-col :sm="24" :md="24" :lg="12">
                <el-card shadow="none">
                   <div slot="header" class="clearfix">
                     <span class="text-primary"><i class="fa fa-globe" />&nbsp;Land Details</span>
                   </div>

                   <select-land-type v-model="rta.landType" :disabled="disabled" />
                   <select-classification-type v-model="rta.classificationType" :disabled="disabled" />

                   <el-row>
                     <el-col :sm="24" :md="12" :lg="8">
                        <time-input label="From Time" v-model="rta.fromTime" :disabled="disabled" />
                    </el-col>

                    <el-col :sm="24" :md="12" :lg="8">
                      <number-input label="Access Hours" prefix="fa fa-hourglass-half" is-prefix-icon :min="0" :max="24" v-model="rta.hoursAccessSite" suffix="hr." :disabled="disabled" />
                    </el-col>

                     <el-col :sm="24" :md="12" :lg="8">
                       <check-box label="Week Days Only" icon="fa fa-calendar-week" v-model="rta.weekDaysOnly" :disabled="disabled" />
                    </el-col>

                    <el-col :sm="24" :md="12" :lg="8">
                      <check-box label="Commerical Power" icon="fa fa-plug" v-model="rta.commercialPowerAvailable" :disabled="disabled"><span v-if="rta.distanceNearestPower">&nbsp;nearest: <b>{{rta.distanceNearestPower}}</b>m.</span></check-box>
                    </el-col>

                    <el-col :sm="24" :md="12" :lg="8">
                      <check-box label="Guidelines" icon="fa fa-list" v-model="rta.guidelines" :disabled="disabled" />
                    </el-col>
                 </el-row>


                </el-card>

              </el-col>

              <el-col :sm="24" :md="24" :lg="12">
                <el-card shadow="none">
                   <div slot="header" class="clearfix">
                     <span class="text-info"><i class="fa fa-broadcast-tower" />&nbsp;Structure Details</span>
                   </div>

                <select-coverage
                    v-model="rta.stationType"
                    label="Station Type"
                    :disabled="disabled"
                     />

                <el-row>
                  <el-col :sm="24" :md="12" :lg="12">
                    <el-form-item label="Structure Supplier" v-if="disabled || isTelco()">
                      <i v-if="rta.supplier.name" class="fa fa-broadcast-tower"></i>
                      &nbsp;{{rta.supplier.name}}
                    </el-form-item>

                    <select-tower-supplier
                      v-else
                      label="Structure Supplier"
                      v-model="rta.supplier"
                      :disabled="disabled || isTelco()"
                      />
                  </el-col>

                  <el-col :sm="24" :md="12" :lg="12">
                    <el-form-item label="Structure Type" v-if="disabled || isTelco()">
                      <i v-if="rta.structure" class="fa fa-broadcast-tower">&nbsp;</i>
                      {{rta.structure.name}}&nbsp;
                      <span v-if="rta.structure && rta.structure.height">
                        {{rta.structure.height}}m.
                      </span>
                    </el-form-item>

                    <select-structure
                      v-else
                      label="Structure Type"
                      v-model="rta.structure_id"
                      :disabled="disabled || isTelco()"
                      />
                  </el-col>

                  <el-col :sm="24" :md="12" :lg="12">
                    <integer-input
                      label="Structure Height"
                      :min="1"
                      :max="121"
                      suffix="m."
                      v-model="rta.structureHeight"
                      :disabled="disabled || isTelco()"
                       />
                   </el-col>

                   <el-col :sm="24" :md="12" :lg="12">
                     <number-input label="Antenna Height" :min="0" :max="121" prefix="fa fa-arrows-alt-v" is-prefix-icon v-model="rta.antennaHeight" suffix="m." :disabled="disabled || isTelco()" />
                   </el-col>

                </el-row>

                </el-card>

              </el-col>

            </el-row>

          </el-tab-pane>




          <el-tab-pane label="Report">

            <html-input label="Report for Client" v-model="rta.report" :disabled="disabled || isTelco()" />

          </el-tab-pane>




          <el-tab-pane v-if="isTowerCo()" label="Land Owner">

            <el-row :gutter="guts">


              <el-col :sm="24" :md="24" :lg="12">
                <el-card shadow="none">
                   <div slot="header" class="clearfix">
                     <span class="text-primary"><i class="fa fa-home" />&nbsp;Owner</span>
                   </div>

                  <select-locality label="Locality" v-model="loc" :disabled="disabled" />

                  <!-- Land owner select -->
                  <select-landlord v-model="rta.owner_id" full-object :disabled="disabled" @change="updateOwner" />

                  <text-input label="Owner" v-model="rta.owner" :disabled="disabled" />
                  <text-input label="Address" v-model="rta.address" :disabled="disabled" />
                  <text-input label="Post Code" v-model="rta.postCode" :disabled="disabled" />

                  <hr />

                  <el-row>

                      <el-col :sm="24" :md="12" :lg="12">
                        <text-input label="Phone" v-model="rta.phone" :disabled="disabled || isTelco()" />
                      </el-col>

                      <el-col :sm="24" :md="12" :lg="12">
                        <text-input label="E-Mail" v-model="rta.email" :disabled="disabled || isTelco()" />
                      </el-col>

                  </el-row>

                </el-card>

              </el-col>


              <el-col :sm="24" :md="24" :lg="12">
                <el-card shadow="none">
                   <div slot="header" class="clearfix">
                     <span class="text-success"><i class="fa fa-globe" />&nbsp;Locality</span>
                   </div>

                  <table class="el-table">
                    <tr v-if="rta.actualLat || rta.actualLng">
                      <td>Geo:</td><td><span>lat: <strong>{{rta.actualLat}}</strong> / lng: <strong>{{rta.actualLng}}</strong></span></td>
                    </tr>
                    <tr v-if="rta.zone">
                      <td></td><td><strong>{{rta.zone}}</strong></td>
                    </tr>
                    <tr v-if="rta.subdistrict || rta.district">
                      <td></td><td><i>{{rta.subdistrict}}</i> <i v-if="rta.district"><span v-if="rta.subdistrict">, </span>{{rta.district}}</i></td>
                    </tr>
                    <tr v-if="rta.state">
                      <td></td><td>{{rta.state}}</td>
                    </tr>
                    <tr v-if="rta.region">
                      <td></td><td><strong>{{rta.region}}</strong></td>
                    </tr>
                    <tr v-if="rta.country">
                      <td></td><td><strong>{{rta.country}}</strong></td>
                    </tr>
                  </table>
                </el-card>
              </el-col>
           </el-row>

          </el-tab-pane>



          <el-tab-pane label="Client Response">

            <select-action-status label="Client Status" placeholder="Client Status" v-model="rta.clientStatus" :disabled="disabled || isTowerCo()" @change="updateClientStatus" />

            <html-input label="Client Remarks" v-model="rta.clientRemarks" :disabled="disabled || isTowerCo()" />

          </el-tab-pane>

        </el-tabs>

        <div v-if="!adding">
          <br />
          <files-panel title="Options Attachments" type="site" :id="site.id" process="candidate" :process-id="rta.id"  :max-files="15" :disabled="disabled || isTelco()" />
        </div>

      </el-form>


  </edit-pane>

  </div>

</template>


<script>

import {jadeMapStyle} from '@/components/maps/styles/GoogleMapStyles'
import {MAP_PINS} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'

import FilesPanel from '@/components/atoms/files/FilesPanel'
import GoogleMap from '@/components/atoms/GoogleMap'

import SelectActionStatus from '@/components/atoms/selects/SelectActionStatus'

import SelectClassificationType from '@/components/atoms/selects/SelectClassificationType'
import SelectCoverage from '@/components/atoms/selects/SelectCoverage'

import SelectLandlord from '@/components/atoms/selects/SelectLandlord'
import SelectLandType from '@/components/atoms/selects/SelectLandType'
import SelectSiteStatus from '@/components/atoms/selects/SelectSiteStatus'

import SelectLocality from '@/components/atoms/selects/SelectLocality'
import SelectStructure from '@/components/atoms/selects/SelectStructure'
import SelectTowerSupplier from '@/components/atoms/selects/SelectTowerSupplier'

export default {

  mixins: [SiteMixins],

  components: {
    GoogleMap,
    FilesPanel,
    SelectClassificationType,
    SelectCoverage,
    SelectLandType,
    SelectActionStatus,
    SelectLocality,
    SelectLandlord,
    SelectSiteStatus,
    SelectStructure,
    SelectTowerSupplier
  },

 props: {

   rowData: {
     type: Object,
     required: true
   },

   siteData: {
     type: Object,
     default: null
   },

   adding: {
     type: Boolean,
     default: false
   },

    rowIndex: {
     type: Number,
     default: null
   }

 },

 methods: {

   approve () {
     this.$confirm('This action add/replace <b>structure</b> and/or <b>landlord details</b>. Continue?', 'Warning', {
       confirmButtonText: 'Yes',
       cancelButtonText: 'No',
       center: true,
       dangerouslyUseHTMLString: true,
       type: 'warning'
     }).then(() => {
       return this.saveForm(this, '/candidate/approve', this.rta.id, this.rta, 'RTA')
     }).catch(() => {
       this.$message({
         type: 'info',
         message: 'Approval cancelled'
       })
     })
   },


   isApproved () {
     return this.rta.clientStatus === 'Approved'
   },


   updateOwner (obj) {

     this.rta.owner_id = obj.id
     this.rta.owner = obj.name

     this.rta.address = obj.address
     this.rta.postCode = obj.postCode

     this.rta.zone = obj.zone
     this.rta.subdistrict = obj.subdistrict
     this.rta.district = obj.district

     this.rta.state = obj.state
     this.rta.region = obj.region
     this.rta.country = obj.country

     this.rta.phone = obj.phone
     this.rta.email = obj.email
   },

   updateMarker (ind, marker) {
     this.updateRequestData(ind, marker)
   },


   updateRequestData (ind, marker) {

     if (marker && marker.type) {

        switch (marker.type) {

              case 'option':
                   this.rta.actualLat = Number(marker.position.lat)
                   this.rta.actualLng = Number(marker.position.lng)

                   this.rta.distanceFromNominal = Number(marker.distance)

                   this.mapCoords[0].candLat = this.rta.actualLat
                   this.mapCoords[0].candLng = this.rta.actualLng
                   this.mapCoords[0].distance = this.rta.distanceFromNominal

                   break

              case 'power':
                   this.rta.distanceNearestPower = Number(marker.distance)
                   break

              case 'access':
                   this.rta.distanceAccessRoad = Number(marker.distance)
                   break

              case 'building':
                   this.rta.distanceNearestBuilding = Number(marker.distance)
                   break


        }

     }

   },



   updateClientStatus (status) {
     this.rta.client_status_at = this.formatDateSql(new Date())
     this.rta.client_status_by = this.userName()
  },


   onEdit () {
     this.disabled = false
   },


   onSave () {

     this.rta.actualLat = Number(this.rta.actualLat)
     this.rta.actualLng = Number(this.rta.actualLng)

     this.rta.region = this.setProp(this.rta.region, this.loc[0])
     this.rta.state = this.setProp(this.rta.state, this.loc[1])
     this.rta.district = this.setProp(this.rta.district, this.loc[2])
     this.rta.subdistrict = this.setProp(this.rta.subdistrict, this.loc[3])
     this.rta.zone = this.setProp(this.rta.zone, this.loc[4])

     this.rta.surveyDate = this.formatDateSql(this.rta.surveyDate)

//     console.log('RTA', this.rta)

     this.disabled = true
     this.saveForm(this, this.url, this.rta.id, this.rta, (this.rta.title ? this.rta.title : 'Option') + ' #' + this.rta.optionNo, null, null, true, this.tableRef)
   },

   onCancel () {
     this.disabled = true
   },

   deleteOption () {
     this.deleteItem(this, this.rta.id, this.url, this.rta.title, this.onDelete)
   },

   onDelete (data) {
//     this.$emit('delete', this.index, this.struct)
//     this.$events.fire(this.tableRef + '-refresh-table')
   }

 },


 data () {

   return {
     guts: 12,
     editable: this.isTelco() || (this.isTowerCo() && this.isManager('project|maintenance|management|property')),
     disabled: this.adding ? false : true,
     loc: [],
     mapPins: MAP_PINS,

     url: '/candidate',
     rta: this.rowData,
     site: this.rowData.options.siteData ? this.rowData.options.siteData : this.siteData,

     mapCoords: [],

     tableRef: 'siteCandidatesTable',
     style: jadeMapStyle
   }
 },

 created () {

   if (this.rta && this.rta.site) {
     this.rta.nominalLat = this.rta.site.latitude
     this.rta.nominalLng = this.rta.site.longitude

     if (!this.rta.structure) {
       this.rta.structure = this.rta.site.structure
//       console.log('rta structure', this.rta.structure, this.rta.site)
     }
   }

   this.loc =
   [this.rta.region,
     this.rta.state,
     this.rta.district,
     this.rta.subdistrict,
     this.rta.zone]

   this.rta.supplier = {}

  this.mapCoords.push({nominalLat: Number(this.rta.nominalLat), nominalLng: Number(this.rta.nominalLng), candLat: Number(this.rta.actualLat), candLng: Number(this.rta.actualLng), distance: Number(this.rta.distanceFromNominal)})
 }

}
</script>



// WEBPACK FOOTER //
// AcquireDetails.vue?675ac7d9